import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const ClassicEditorContextProviderLazyLoader: LoadableType<{
	children: any;
	isWithinEditor?: boolean | undefined;
}> = LoadableLazy({
	name: 'ClassicEditorContextProviderLazyLoader',

	loader: () =>
		import(
			/* webpackChunkName: "loadable-ClassicEditorContextProvider" */ './ClassicEditorContextProvider.js'
		),
});
